// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1293":"27d3cabf21b7dbc1","4506":"cc3010d1fed0e5af","6310":"6244c5f8da5148b4","6354":"928c76000ca4f4ec"}[chunkId] + ".css";
};